// ─── SignNow template IDs ─────────────────────────────────────────────────────
// Replace with real IDs from app.signnow.com/webapp/template/{ID}

export const SIGNNOW_TEMPLATES = {
  contract: "4256092e27d540cb8dd7ad12db30fdf35b457086",
  nda:      "705981fa8058452485b5e02281de792d395d8de2",
  w9:       "8c4e386f80ea46cd8b22c9f61208e3ad98266a01",
};

// ─── Onboarding document definitions ─────────────────────────────────────────
// Single source of truth for which docs exist, their labels, and which
// onboarding flag they map to. Add future documents here.

export const ONBOARDING_DOCS = [
  {
    docKey:     "contract",
    docLabel:   "Independent Contractor Agreement",
    templateId: SIGNNOW_TEMPLATES.contract,
    onboardingKey: "contract_signed",   // key inside user.onboarding
  },
  {
    docKey:     "nda",
    docLabel:   "Non-Disclosure Agreement",
    templateId: SIGNNOW_TEMPLATES.nda,
    onboardingKey: "nda_signed",
  },
  {
    docKey:     "tax",
    docLabel:   "W-9 Tax Form",
    templateId: SIGNNOW_TEMPLATES.w9,
    onboardingKey: "tax_form_signed",
  },
];

// ─── API helpers ──────────────────────────────────────────────────────────────

/**
 * Request a signing link from your backend.
 * Returns { signingLink, documentId } on success, throws on failure.
 */
export async function requestSigningLink({ templateId, signerEmail, signerName, documentName }) {
  const res = await fetch("/api/signnow/invite", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ templateId, signerEmail, signerName, documentName }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error ?? JSON.stringify(data));
  if (!data.signingLink) throw new Error("No signing link returned from SignNow.");
  return data; // { signingLink, documentId }
}

/**
 * Check whether a document has been signed.
 * Returns { signed: boolean }.
 */
export async function checkSigningStatus(documentId) {
  const res = await fetch(`/api/signnow/status?documentId=${documentId}`);
  return res.json(); // { signed: boolean }
}

// ─── Onboarding status helpers ────────────────────────────────────────────────

/**
 * Returns an array of doc status objects derived from user.onboarding.
 * Safe to call with null/undefined onboarding.
 */
export function getDocStatus(onboarding) {
  return ONBOARDING_DOCS.map(doc => ({
    ...doc,
    signed: onboarding?.[doc.onboardingKey] ?? false,
  }));
}

/**
 * Returns true only when every onboarding document has been signed.
 */
export function allDocsSigned(onboarding) {
  return ONBOARDING_DOCS.every(doc => onboarding?.[doc.onboardingKey] === true);
}

/**
 * Maps a docKey back to its onboarding flag name.
 * e.g. "contract" → "contract_signed"
 */
export function docKeyToOnboardingKey(docKey) {
  return ONBOARDING_DOCS.find(d => d.docKey === docKey)?.onboardingKey ?? null;
}